/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-regex-literals */
/* eslint-disable import/extensions */
/* eslint-disable import/order */
/* eslint no-use-before-define: 0 */
import React from "react";
import Button from "../../common/Button";
import Icon from "../../common/Icon";

const CodeToTextButton = props => {
  const { handleButtonClick } = props;

  return (
    <>
      <Button
        format="insert Html"
        onClick={() => handleButtonClick({ showInput: true, action: "insert" })}
      >
        <Icon icon="insertHtml" />
      </Button>
    </>
  );
};

export default CodeToTextButton;
